import { $emit as c } from "../utils/gogocodeTransfer.js";
import p from "../loading/index.js";
import { resolveComponent as v, openBlock as e, createElementBlock as r, createElementVNode as m, renderSlot as n, createBlock as L, createCommentVNode as s, toDisplayString as M } from "vue";
import { _ } from "../_plugin-vue_export-helper-dad06003.js";
let a;
const h = {
  name: "rLoadMore",
  components: {
    Loading: p
  },
  props: {
    /**
     * 类型：点击文字或到底加载，click | reach
     */
    type: {
      type: String,
      default: "reach"
    },
    /**
     * 显示加载
     */
    showLoadMore: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    {
      /**
       * 该去请求更多数据了
       */
      toLoadMore: null
    },
    "toLoadMore"
  ],
  methods: {
    toLoadMore() {
      c(this, "toLoadMore");
    }
  },
  mounted() {
    this.type === "reach" && (a = new IntersectionObserver((o) => {
      for (const t of o)
        t.isIntersecting && c(this, "toLoadMore");
    }), a.observe(this.$refs.loading));
  },
  beforeUnmount() {
    a && a.disconnect();
  }
}, g = { class: "r-load-more" }, k = { class: "r-load-more-wrapper" }, y = {
  class: "r-load-more-loading",
  ref: "loading"
}, $ = { key: 0 }, b = {
  key: 0,
  class: "r-load-more-text"
};
function w(o, t, d, B, C, l) {
  const f = v("Loading");
  return e(), r("div", g, [
    m("div", k, [
      n(o.$slots, "default")
    ]),
    m(
      "div",
      y,
      [
        d.showLoadMore ? (e(), r("div", $, [
          o.$slots.loadMoreLoading ? s("v-if", !0) : (e(), L(f, { key: 0 })),
          n(o.$slots, "loadMoreLoading")
        ])) : s("v-if", !0),
        d.type === "click" && !d.showLoadMore ? (e(), r("div", {
          key: 1,
          onClick: t[0] || (t[0] = (...u) => l.toLoadMore && l.toLoadMore(...u)),
          class: "r-load-more-click"
        }, [
          o.$slots.loadMoreText ? s("v-if", !0) : (e(), r(
            "div",
            b,
            M(o.$t("bmui-load-more.text")),
            1
            /* TEXT */
          )),
          n(o.$slots, "loadMoreText")
        ])) : s("v-if", !0)
      ],
      512
      /* NEED_PATCH */
    )
  ]);
}
const i = /* @__PURE__ */ _(h, [["render", w], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/load-more/load-more.vue"]]);
i.install = function(o) {
  o.component(i.name, i);
};
export {
  i as default
};
